module.exports = __webpack_public_path__ + "files/becd7b382407e42a70ab3e20bb352a5f.png";